import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";

import {
  setSelectedRowIds,
  openTaskModal,
  changeSearch,
} from "app/store/tasks/slice/taskSlice";
import useDebounce from "app/hooks/useDebounce";

const useTaskTable = (selectedTab) => {
  const dispatch = useDispatch();
  const { searchText } = useSelector((state) => state.task);

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 50,
  });

  const [sorting, setSorting] = useState([]);
  const [columnFilters, setColumnFilters] = useState([]);
  const [search, setSearch] = useState("");
  const [columnVisibility, setColumnVisibility] = useState({});

  useEffect(() => {
    const isAuditedOrAuditedArchivedTab = [
      "audited",
      "audited-archived",
    ].includes(selectedTab);
    const allowedActionTabs = ["archived", "audited-archived"];
    const isPendingApprovalsTab = ["pending-approvals"].includes(selectedTab);

    setColumnVisibility({
      action: !allowedActionTabs.includes(selectedTab) || false,
      date: !isAuditedOrAuditedArchivedTab || false,
      status:
        (!isAuditedOrAuditedArchivedTab && !isPendingApprovalsTab) || false,
      created_at: isAuditedOrAuditedArchivedTab || false,
      created_by: isAuditedOrAuditedArchivedTab || false,
      report_date: isAuditedOrAuditedArchivedTab || false,
      request_from: isPendingApprovalsTab || false,
      reason: isPendingApprovalsTab || false,
      notes: isPendingApprovalsTab || false,
      account: !isPendingApprovalsTab || false,
    });
  }, [selectedTab]);

  const handleRowSelection = (rows) => {
    const rowIds = rows.map((row) => {
      return row.id;
    });
    dispatch(setSelectedRowIds(rowIds));
  };

  const handleRowClick = (rowData) => {
    const selectedTask = Object.assign({}, rowData);
    dispatch(
      openTaskModal({
        selectedTask,
        taskModalOpen: true,
        requestType: "PUT",
        taskModalTitle: "Update Task Information",
      })
    );
  };

  const onSearchChange = useDebounce((value) => {
    setSearch(value || undefined);
    dispatch(changeSearch(value));
  }, 1600);

  return {
    columnFilters,
    handleRowSelection,
    handleRowClick,
    pagination,
    sorting,

    setPagination,
    setSorting,
    setColumnFilters,

    search,
    onSearchChange,
    searchText,
    columnVisibility,
  };
};

export default useTaskTable;
